<div fxLayout="row wrap">
  <div fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="m-b-20">
          <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxLayoutGap.lt-md="20px">
            <div fxFlex.gt-sm="17" fxFlex="100">
              <h3>Appointment</h3>
            </div>
            <div fxFlex.gt-sm="57" fxLayout="row" fxFlex="100" fxLayoutAlign="end start">
              <button mat-raised-button color="primary" (click)="booking()">Schedule Appointment</button>
            </div>
          </div>
          <table mat-table *ngIf="dataSource.length" [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Service Type</th>
              <td mat-cell *matCellDef="let element"> {{element.resource.name}} </td>
            </ng-container>
            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef> Date </th>
              <td mat-cell *matCellDef="let element"> {{element.startDate |  date:'MM/DD/YYYY'}} </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef> Time </th>
              <td mat-cell *matCellDef="let element"> {{element.startTime| slice:0:5}} - {{element.endTime | slice:0:5}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <ng-container *matCellDef="let element">
                <td mat-cell class="status" [ngClass]="{'upcoming': element.bookingStatus === 'Booked', 'expaired': element.bookingStatus === 'Expaired', 'cancelled': element.bookingStatus === 'Cancelled', 'ongoing': element.bookingStatus === 'On going'}">{{element.bookingStatus}}</td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let element">
                <button  *ngIf="element.bookingStatus === 'Booked'" class="cacel-button btn" mat-raised-button color="warn" (click)="cancelConfirmation(element.id)">Cancel</button>
                <button  *ngIf="element.bookingStatus === 'Booked'" mat-raised-button color="primary" class="btn" (click)="rescheduleBooking(element)">Reschedule</button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="!dataSource.length && isAPICalled">
            <h3>No appointment available</h3>
          </div>
          <!-- <div *ngFor="let item of dataSource; let i=index;">
            <div fxLayout="row wrap">
              <h4>{{item.resource.name}}</h4>
            </div>
            <div fxLayout="row wrap">
              <div fxFlex="15" fxLayoutAlign="start center">
                <mat-icon class="m-r-5">calendar_today</mat-icon>
                <span class="time">{{item.startDate |  date:'MM/DD/YYYY'}}</span>
              </div>
              <div fxFlex="15" fxLayoutAlign="start center">
                <mat-icon class="m-r-5">access_time</mat-icon>
                <span class="time">{{item.startTime| slice:0:5}} - {{item.endTime | slice:0:5}}</span>
              </div>
              <div fxFlex="10" fxLayoutAlign="start center">
                  <span class="status" [ngClass]="{'upcoming': item.bookingStatus === 'Upcoming', 'expaired': item.bookingStatus === 'Expaired', 'cancelled': item.bookingStatus === 'Cancelled', 'ongoing': item.bookingStatus === 'On going'}">{{item.bookingStatus}}</span>
                </div>
              <div fxFlex="13" fxLayoutAlign="space-between center">
                  <button  *ngIf="item.bookingStatus === 'Upcoming'" class="cacel-button btn" mat-raised-button color="warn" (click)="cancelConfirmation(item.id)">Cancel</button>
                  <button  *ngIf="item.bookingStatus === 'Upcoming'" mat-raised-button color="primary" class="btn" (click)="rescheduleBooking(item)">Reschedule</button>
              </div>
            </div>
            <mat-divider class="m-t-10" *ngIf="i<dataSource.length-1"></mat-divider>
          </div> -->
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>